import React from 'react';
import AssortedDisclaimer from './components/assorted-disclaimer';
import UsedDisclaimer from './components/used-disclaimer';

class ProductDisclaimer extends React.Component {
  render() {
    const { currentSku, product, history } = this.props;
    return (
      <div>
        <UsedDisclaimer currentSku={currentSku} history={history} />
        <AssortedDisclaimer product={product} history={history} />
      </div>
    );
  }
}

export default ProductDisclaimer;
